import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchAgents, fetchAgentsContent } from 'Components/InfoAgents/Redux/thunks';
import InfoAgents from 'Components/InfoAgents/InfoAgents';

import { 
  getAgents, 
  getAgentsContent,
  getIsFetching, 
  getIsFetchFailed, 
} from 'Components/InfoAgents/Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  agents: Julius.Website.AgentViewModel[];
  content: Julius.Website.AgentsPageViewModel;
  fetchAgents: () => void;
  fetchAgentsContent: () => void;
}

type Props = IPropsInternal;

class InfoAgentsContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchAgents();
    this.props.fetchAgentsContent();
  }

  render() {
    return (
      <InfoAgents
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed } 
        agents={ this.props.agents }
        content={ this.props.content }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    isFetchFailed: getIsFetchFailed(state),
    agents: getAgents(state),
    content: getAgentsContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchAgents,
    fetchAgentsContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoAgentsContainer);


// WEBPACK FOOTER //
// ./src/components/InfoAgents/InfoAgentsContainer.tsx